import {BaseModel} from '../base.model';

export class AuthModel extends BaseModel {

	token: string;
	dossier: string;
	id: number;
	initdata: boolean;
	uid: string;

	constructor() {
		super();
	}

}
